<div class="p-4 flex flex-col gap-4">
	<h1 class="text-2xl mb-4">PrimeNG Komponenten Übersicht</h1>

	<section>
		<h2>Colors</h2>
		<div class="">
			@for(a of aeotec; track a) {
			<div>
				aeotec-{{ a }}
				<i class="inline-flex rounded-full w-8 h-8 overflow-hidden" [style]="'background-color: var(--p-aeotec-' + a + ')'"></i>
			</div>
			}
		</div>
	</section>

	<!-- Paginator -->
	<section>
		<h2>Paginator</h2>
		<p-paginator
			(onPageChange)="onPageChange($event)"
			[first]="first"
			[rows]="rows"
			[totalRecords]="120"
			[rowsPerPageOptions]="[10, 20, 30]" />
	</section>

	<!-- Buttons -->
	<section class="flex flex-col gap-2">
		<h2 class="mb-2">Button</h2>
		<div class="flex gap-2">
			<p-button label="Primary" />
			<p-button label="Secondary" severity="secondary" />
			<p-button label="Success" severity="success" />
			<p-button label="Info" severity="info" />
			<p-button label="Warn" severity="warn" />
			<p-button label="Help" severity="help" />
			<p-button label="Danger" severity="danger" />
			<p-button label="Contrast" severity="contrast" />
		</div>
		<div class="flex gap-2">
			<p-button label="Primary" [raised]="true" />
			<p-button label="Secondary" severity="secondary" [raised]="true" />
			<p-button label="Success" severity="success" [raised]="true" />
			<p-button label="Info" severity="info" [raised]="true" />
			<p-button label="Warn" severity="warn" [raised]="true" />
			<p-button label="Help" severity="help" [raised]="true" />
			<p-button label="Danger" severity="danger" [raised]="true" />
			<p-button label="Contrast" severity="contrast" [raised]="true" />
		</div>
		<div class="flex gap-2">
			<p-button label="Primary" variant="text" />
			<p-button label="Secondary" severity="secondary" variant="text" />
			<p-button label="Success" severity="success" variant="text" />
			<p-button label="Info" severity="info" variant="text" />
			<p-button label="Warn" severity="warn" variant="text" />
			<p-button label="Help" severity="help" variant="text" />
			<p-button label="Danger" severity="danger" variant="text" />
			<p-button label="Contrast" severity="contrast" variant="text" />
		</div>
		<div class="flex gap-2">
			<p-button label="Primary" variant="outlined" />
			<p-button label="Secondary" severity="secondary" variant="outlined" />
			<p-button label="Success" severity="success" variant="outlined" />
			<p-button label="Info" severity="info" variant="outlined" />
			<p-button label="Warn" severity="warn" variant="outlined" />
			<p-button label="Help" severity="help" variant="outlined" />
			<p-button label="Danger" severity="danger" variant="outlined" />
			<p-button label="Contrast" severity="contrast" variant="outlined" />
		</div>
	</section>

	<!-- InputText -->
	<section>
		<h2>InputText</h2>
		<input pInputText type="text" placeholder="Text eingeben" />
	</section>

	<!-- Textarea -->
	<section>
		<h2>Textarea</h2>
		<textarea pInputTextarea rows="3" cols="30"></textarea>
	</section>

	<!-- InputNumber -->
	<section>
		<h2>InputNumber</h2>
		<p-inputNumber [(ngModel)]="value"></p-inputNumber>
	</section>

	<!-- Calendar -->
	<section>
		<h2>Calendar</h2>
		<p-calendar [(ngModel)]="selectedDate"></p-calendar>
	</section>

	<!-- Dropdown -->
	<section>
		<h2>Dropdown</h2>
		<p-dropdown [options]="cities" [(ngModel)]="selectedCity" placeholder="Stadt wählen"></p-dropdown>
	</section>

	<!-- MultiSelect -->
	<section>
		<h2>MultiSelect</h2>
		<p-multiSelect [options]="cities" [(ngModel)]="selectedCities" defaultLabel="Städte wählen"></p-multiSelect>
	</section>

	<!-- Checkbox -->
	<section>
		<h2>Checkbox</h2>
		<p-checkbox label="Option A" [(ngModel)]="checked"></p-checkbox>
	</section>

	<!-- RadioButton -->
	<section>
		<h2>RadioButton</h2>
		<p-radioButton name="group1" value="A" [(ngModel)]="radioValue" label="Option A"></p-radioButton>
		<p-radioButton name="group1" value="B" [(ngModel)]="radioValue" label="Option B"></p-radioButton>
	</section>

	<!-- Slider -->
	<section>
		<h2>Slider</h2>
		<p-slider [(ngModel)]="sliderValue"></p-slider>
	</section>

	<!-- Table -->
	<section>
		<h2>Table</h2>
		<p-table [value]="products">
			<ng-template pTemplate="header">
				<tr>
					<th>Name</th>
					<th>Preis</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-product>
				<tr>
					<td>{{ product.name }}</td>
					<td>{{ product.price }}</td>
				</tr>
			</ng-template>
		</p-table>
	</section>

	<!-- Accordion -->
	<section>
		<h2>Accordion</h2>
		<p-accordion>
			<p-accordionTab header="Tab 1"> Inhalt 1 </p-accordionTab>
			<p-accordionTab header="Tab 2"> Inhalt 2 </p-accordionTab>
		</p-accordion>
	</section>

	<!-- TabView -->
	<section>
		<h2>TabView</h2>
		<p-tabView>
			<p-tabPanel header="Tab A">Inhalt A</p-tabPanel>
			<p-tabPanel header="Tab B">Inhalt B</p-tabPanel>
		</p-tabView>
	</section>

	<!-- Dialog -->
	<section>
		<h2>Dialog</h2>
		<button pButton (click)="showDialog = true" label="Dialog öffnen"></button>
		<p-dialog header="Dialog Titel" [(visible)]="showDialog" [modal]="true" [closable]="true">
			<p>Dialog-Inhalt</p>
		</p-dialog>
	</section>

	<!-- Toast -->
	<section>
		<h2>Toast</h2>
		<button pButton (click)="showToast()" label="Toast anzeigen"></button>
		<p-toast></p-toast>
	</section>

	<!-- Messages -->
	<section>
		<h2>Messages</h2>
		<p-messages [(value)]="msgs"></p-messages>
	</section>

	<!-- ProgressBar -->
	<section>
		<h2>ProgressBar</h2>
		<p-progressBar [value]="progress"></p-progressBar>
	</section>

	<!-- Tooltip -->
	<section>
		<h2>Tooltip</h2>
		<button pButton label="Hover mich" pTooltip="Ich bin ein Tooltip!"></button>
	</section>

	<!-- Chips -->
	<section>
		<h2>Chips</h2>
		<p-chips [(ngModel)]="chips"></p-chips>
	</section>

	<!-- Badge -->
	<section>
		<h2>Badge</h2>
		<button pButton label="Nachrichten" pBadge value="5"></button>
	</section>
</div>
